import React from "react";
import CookieConsent from "react-cookie-consent";
import { Link } from "@flogy/gatsby-theme-fgs-layout";
import useThemeOptions from "../hooks/useThemeOptions";
import cookieConsentStyles from "./cookie-consent-styles";

export const CookieConsentRootWrapper = ({ children }) => {
  const themeOptions = useThemeOptions();

  if (!themeOptions.cookieBanner.enable) {
    return children;
  }

  return (
    <>
      <CookieConsent
        buttonText="OK, verstanden"
        cookieName="user-accepted-cookies"
        sameSite="strict"
        {...cookieConsentStyles}
      >
        Um bestmögliche Funktionalität zu bieten nutzt diese Website Cookies zu
        den in der{" "}
        <Link href={themeOptions.dataPrivacy.path}>Datenschutzerklärung</Link>{" "}
        beschriebenen Zwecken. Mit der Nutzung dieser Website erklären Sie sich
        damit einverstanden.
      </CookieConsent>
      {children}
    </>
  );
};
